import { compileHTML, compileCSS } from './compile.js'

const fontSpider = require('font-spider')
const fs = require('fs')
const path = require('path')

const HTML_TEMPLATE =
  `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <link rel="stylesheet" href="./font.css">
  <title>font-compression-template</title>
</head>
<body>
  <!-- html inner -->
</body>
</html>
`

const HTML_INNER_MARK = '<!-- html inner -->'
const CSS_INNER_MARK = '/* css inner */'

const createFileHTML = (content, fileName, baseUrl) => {
  const _path = `${baseUrl}${fileName}`
  return new Promise((resolve) => {
    fs.mkdir(path.resolve(baseUrl), { recursive: true }, (err) => {
      if (err) {
        resolve(err)
      } else {
        fs.writeFile(_path, content, (err) => {
          if (err) {
            console.log('error>> :', err)
          } else {
            console.log('HTMLTemplate created successfully')
          }
          resolve(err)
        })
      }
    })
  })
}

const createFileCSS = (content, baseUrl) => {
  const _path = `${baseUrl}font.css`
  return new Promise((resolve) => {
    fs.mkdir(path.resolve(baseUrl), { recursive: true }, (err) => {
      if (err) {
        resolve(err)
      } else {
        fs.writeFile(_path, content, (err) => {
          if (err) {
            console.log('error>> :', err)
          } else {
            console.log('CSSTemplate created successfully')
          }
          resolve(err)
        })
      }
    })
  })
}

const copyFontFile = (fontList, baseUrl) => {
  fontList.forEach(item => {
    const originFontFile = `${path.resolve(item.fontDir)}.ttf`
    const outputFontFile = path.resolve(__dirname, `${path.resolve(baseUrl)}/${item.fontName}.ttf`)
    fs.copyFile(originFontFile, outputFontFile, 0, (err) => {
      if (err) {
        console.log('copy error>> :', err)
        throw err
      }
      console.log(`copy ${item.fontName} successfully`)
    })
  })
}

class FontCompressionPlugin {
  constructor({ fontList, htmlFile, baseUrl, isProEnv }) {
    if (!fontList) {
      throw new Error('Please input your font list!')
    }
    this.fontList = fontList
    this.htmlFile = htmlFile || 'font.html'
    this.baseUrl = baseUrl || 'src/assets/font/'
    this.isProEnv = isProEnv || false
  }

  apply(compiler) {
    compiler.hooks.afterPlugins.tap('@tripmini/font-compression-plugin', async () => {
      await copyFontFile(this.fontList, this.baseUrl)

      const _htmlTemplateStr = compileHTML(this.fontList)
      const _cssTemplateStr = compileCSS(this.fontList, this.isProEnv)
      const _templateHTML = HTML_TEMPLATE
      const _templateCSS = CSS_INNER_MARK

      const _finalFontHTML = _templateHTML.replace(HTML_INNER_MARK, _htmlTemplateStr)
      const _finalFontCSS = _templateCSS.replace(CSS_INNER_MARK, _cssTemplateStr)

      await createFileHTML(_finalFontHTML, this.htmlFile, this.baseUrl);
      await createFileCSS(_finalFontCSS, this.baseUrl);

      if (this.isProEnv) {
        const fontHtmlPath = `${path.resolve(this.baseUrl)}/${this.htmlFile}` // 字体路径
        await fontSpider
          .spider([fontHtmlPath], {
            silent: false
          })
          .then(function (webFonts) {
            return fontSpider.compressor(webFonts, { backup: true })
          }).then(function (webFonts) {
            console.log("webFonts>> :", webFonts)
          })
          .catch(function (errors) {
            console.error(errors)
          })
      }
    })
  }
}

module.exports = FontCompressionPlugin